export const userColumns = [
  {
    title: "Full Name",
    dataIndex: "fullname",
    key: "fullname",
  },
  {
    title: "User Name",
    dataIndex: "username",
    key: "username",
  },
];

export const courseColumns = [
  {
    title: "S.No",
    key: "serial",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Course Name",
    dataIndex: "courseName",
    key: "courseName",
  },
];
